export default __webpack_public_path__ + "static/media/flag3.ab1cdfa4.jpg";